// The SEN66 reports CUMULATIVE "smaller than X um" number concentration in
// #/cm³. The legacy PTQS1005 reported the opposite convention — cumulative
// "larger than X um", per 100 cm³ — and some views still want that shape.
//
// The firmware used to do this subtraction before anything else saw the data.
// It no longer does, because the two operands are nearly equal indoors (almost
// every particle is sub-micron) and each is quantised at the sensor's 0.1
// #/cm³ LSB, so the difference could only ever move in steps of 10 counts:
// across a real 24-second capture the 1um bin never left 40 and the 2.5um bin
// toggled between 0 and 10. Deriving it here instead does not make it finer —
// the step is the sensor's, not the code's — but it keeps the honest
// cumulative reading available to everything else, and it is exact, where the
// device's float pipeline turned a true 780 into 779.
//
// Use this for compatibility with the old presentation, not as a default
// display: only the 0.5um bin has enough delta to carry a usable signal.
export function largerThan(totalPerCm3, belowPerCm3) {
  if (!Number.isFinite(totalPerCm3) || !Number.isFinite(belowPerCm3)) return null;
  const delta = totalPerCm3 - belowPerCm3;
  // A negative delta is not a measurement. It means the two bins came from
  // different samples, so report absence rather than clamping to a 0 that
  // reads as "no particles this size".
  if (delta < 0) return null;
  return Math.round(delta * 100);
}

// Convenience over a mapped readings object.
export function legacyBinsFrom(r) {
  const total = r ? r.nc100 : undefined;
  return {
    pc05: largerThan(total, r ? r.nc05 : undefined),
    pc10: largerThan(total, r ? r.nc10 : undefined),
    pc25: largerThan(total, r ? r.nc25 : undefined),
    pc40: largerThan(total, r ? r.nc40 : undefined),
  };
}
